import { ref } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "revenue-content"
};
import RevenueHeader from '@/views/paidDownloads/paidKanban/components/RevenueHeader.vue';
import EchartsContent from '@/views/paidDownloads/paidKanban/components/EchartsContent.vue';
import TableContent from '@/views/paidDownloads/paidKanban/components/TableContent.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const echartRef = ref(null),
      tableRef = ref(null);
    const returnSearch = obj => {
      var _echartRef$value, _tableRef$value;
      (_echartRef$value = echartRef.value) === null || _echartRef$value === void 0 || _echartRef$value.getData(obj);
      (_tableRef$value = tableRef.value) === null || _tableRef$value === void 0 || _tableRef$value.searchData(obj);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(RevenueHeader, {
        onReturnSearch: returnSearch
      }), _createVNode(EchartsContent, {
        ref_key: "echartRef",
        ref: echartRef
      }, null, 512), _createVNode(TableContent, {
        ref_key: "tableRef",
        ref: tableRef
      }, null, 512)]);
    };
  }
});